import React from 'react';
import { ImpulseSpinner } from 'react-spinners-kit';

function Loader() {
	return (
		<div
			style={{ minHeight: '300px' }}
			className="w-100 d-flex justify-content-center align-items-center flex-grow-1"
		>
			<ImpulseSpinner size={60} frontColor="#2EA0DF"></ImpulseSpinner>
		</div>
	);
}

export default Loader;
